import { render, staticRenderFns } from "./TheAboutUs.vue?vue&type=template&id=30f4daf2&scoped=true"
import script from "./TheAboutUs.vue?vue&type=script&lang=js"
export * from "./TheAboutUs.vue?vue&type=script&lang=js"
import style0 from "./TheAboutUs.vue?vue&type=style&index=0&id=30f4daf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4daf2",
  null
  
)

export default component.exports